import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';

import { fullWidth } from '@components/frame';

export const useContainerPositionRef = () => {
  const containerRef = useRef<View>(null);
  const [containerPosition, setContainerPosition] = useState({ top: 0, right: 0, left: 0, bottom: 0 });

  useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    container.measure((x, y, width, height, pageX, pageY) => {
      const left = pageX;
      const bottom = pageY;
      const right = fullWidth - left - width;
      const top = bottom + height;

      setContainerPosition({ right, top, bottom, left });
    });
  }, [containerRef]);

  return [containerRef, containerPosition] as const;
};
